import configureStore from "./configureStore";
import React from "react";
import {initStore} from "../portal/constants/systemConstants";

const store = configureStore();

let storeContext = React.createContext(store);
initStore(store.dispatch, storeContext);

export default store;